import { render, staticRenderFns } from "./DraftNCF.vue?vue&type=template&id=f0d75bd2&scoped=true&"
import script from "./DraftNCF.vue?vue&type=script&lang=js&"
export * from "./DraftNCF.vue?vue&type=script&lang=js&"
import style0 from "./DraftNCF.vue?vue&type=style&index=0&id=f0d75bd2&prod&lang=scss&scoped=true&"
import style1 from "./DraftNCF.vue?vue&type=style&index=1&id=f0d75bd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d75bd2",
  null
  
)

export default component.exports